import React from 'react';
import styles from '../DonationForm.module.css';

// The 'Your Information' guest-donor fields (donation-for + first/last name +
// email + phone). Extracted VERBATIM from DonationForm's render; the parent
// keeps the {!user && (...)} gate.
export default function DonorInfoSection({
  donationFor, email, firstName, lastName, phone,
  setDonationFor, setEmail, setFirstName, setLastName, setPhone,
}) {
  return (
              <div className={styles.formSection}>
                <h4 className={styles.sectionTitle}>Your Information</h4>
    
                <div>
                  <label htmlFor="donationFor" className={styles.label}>Donation For: *</label>
                  <input
                    className={styles.input}
                    type="text"
                    id="donationFor"
                    required
                    placeholder="e.g., General Donation/Sadaqah"
                    value={donationFor}
                    onChange={(e) => setDonationFor(e.target.value)}
                  />
                </div>
                
                <div>
                  <label htmlFor="firstName" className={styles.label}>First Name *</label>
                  <input
                    className={styles.input}
                    type="text"
                    id="firstName"
                    required
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
    
                <div>
                  <label htmlFor="lastName" className={styles.label}>Last Name *</label>
                  <input
                    className={styles.input}
                    type="text"
                    id="lastName"
                    required
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
    
                <div>
                  <label htmlFor="email" className={styles.label}>Email (Optional)</label>
                  <input
                    className={styles.input}
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
    
                <div>
                  <label htmlFor="phone" className={styles.label}>Phone (Optional)</label>
                  <input
                    className={styles.input}
                    type="tel"
                    id="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
              </div>
  );
}
